import { formatUTCDateWithTZ } from '../../../utils/timezone';
import { ResidentLocationFields, ResidentLocationParts } from '../../../types/resident-location';
import sendToast from '../../../utils/Toast';

const PREMISE_STATUS = { ON: "On Premise", OFF: "Off Premise" } as const;

export function formatResidentLocationParts(
    activeResident: ResidentLocationFields | null,
    facilityTimeZone: string,
    isOnNeighborsAppRoute: boolean,
): ResidentLocationParts | null {
    const lastLocation = activeResident?.LastLocation?.trim();
    if (!lastLocation) return null;

    const isOffPremise = lastLocation === PREMISE_STATUS.OFF;
    const shortLocation = isOnNeighborsAppRoute ? (isOffPremise ? PREMISE_STATUS.OFF : PREMISE_STATUS.ON) : `Location: ${lastLocation}`;

    const lastLocationAt = activeResident?.LastLocationAt;
    const timezone = facilityTimeZone?.trim();

    if (lastLocationAt == null || lastLocationAt === '' || !timezone) {
        return { shortLocation, fullLocation: null, isOffPremise };
    }

    let fullLocation: string | null = null;
    try {
        const time = formatUTCDateWithTZ(lastLocationAt, 'hh:mm A', timezone);
        const date = formatUTCDateWithTZ(lastLocationAt, 'M/D', timezone);
        const timeDate = `${time} on ${date}`;
        const appLocation = () => isOffPremise ? `Last seen: ${timeDate}` : `Room ${lastLocation} · ${timeDate}`;
        fullLocation = isOnNeighborsAppRoute ? appLocation() : `Location: ${lastLocation} @ ${timeDate}`;
    } catch {
        sendToast('error', 'Error formatting resident location');
    }
    return { shortLocation, fullLocation, isOffPremise };
}